function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuitaXica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M10.634,6.399c0.078,1.219,0.141,2.439,0.2,3.658c0.032,0.605,0.049,1.213,0.068,1.818"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M5.595,23.996c0.344-0.041,0.589-0.383,0.636-0.726c0.08-0.588-0.19-1.399-0.278-1.991 c-0.52-3.495-0.965-6.988-0.624-10.533c0.177-1.839,0.3-1.94,1.874-1.058c0.842,0.472,1.692,0.785,2.662,0.806 c0.396,0.008,0.767,0.187,0.736,0.672c-0.027,0.429-0.382,0.487-0.728,0.474c-0.65-0.023-1.602-0.181-1.463,0.745 c0.122,0.816,0.689,1.781,1.72,1.872c3.368,0.297,6.76,0.311,10.109,0.854c0.52,0.084,0.974-0.092,1.077-0.651 c0.108-0.587-0.318-0.849-0.817-0.953c-1.8-0.374-3.634-0.677-5.457-0.554c-1.278,0.087-1.615-1.225-2.682-1.402 c-0.292-0.049-0.068-0.699,0.383-0.774c0.409-0.068,0.838-0.012,1.259-0.005c1.063,0.018,1.81-0.718,1.862-1.76 c0.038-0.746,0.166-1.487,0.248-2.231c0.217-1.98-1.099-3.502-2.987-3.013c-2.155,0.558-3.599-0.536-5.197-1.483 C7.56,2.068,7.292,1.862,7.673,1.424C8.131,0.9,7.635,0.467,7.509,0C7.227,0,6.945,0,6.662,0C4.67,2.302,4.72,5.288,4.146,8.011 c-1.012,4.805-0.297,9.638,0.365,14.443c0.05,0.361,0.154,0.814,0.346,1.125c0.096,0.155,0.239,0.289,0.403,0.362 C5.365,23.988,5.479,24.01,5.595,23.996z M6.601,4.244c0.1-0.304,0.397-0.359,0.727-0.36C7.895,3.972,8.326,4.313,8.55,4.86 c0.233,0.568,0.101,1.11-0.343,1.531C8.012,6.576,7.732,6.733,7.45,6.536C7.149,6.325,7.408,6.139,7.522,5.963 C7.92,5.349,7.82,4.919,7.071,4.732C6.803,4.665,6.469,4.644,6.601,4.244z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuitaXica);
export default __webpack_public_path__ + "static/media/guita-xica.efd269c54510417cd51ea210966bf02f.svg";
export { ForwardRef as ReactComponent };